// Interior images for gallery

import galleryImg1 from '../Assets/Gallery/galleryImg1.jpg'
import galleryImg2 from '../Assets/Gallery/galleryImg2.jpg'
import galleryImg3 from '../Assets/Gallery/galleryImg3.jpg'
import galleryImg4 from '../Assets/Gallery/galleryImg4.jpg'
import galleryImg5 from '../Assets/Gallery/galleryImg5.jpg'
import galleryImg6 from '../Assets/Gallery/galleryImg6.jpg'
import galleryImg7 from '../Assets/Gallery/galleryImg7.jpg'
import galleryImg8 from '../Assets/Gallery/galleryImg8.jpg'
import galleryImg9 from '../Assets/Gallery/galleryImg9.jpg'
import galleryImg10 from '../Assets/Gallery/galleryImg10.jpg'
import galleryImg11 from '../Assets/Gallery/galleryImg11.jpg'
import galleryImg12 from '../Assets/Gallery/galleryImg12.jpg'
import galleryImg13 from '../Assets/Gallery/galleryImg13.jpg'

// Food images for gallery

import galleryFood1 from '../Assets/Gallery/galleryFood1.jpg'
import galleryFood2 from '../Assets/Gallery/galleryFood2.jpg'
import galleryFood3 from '../Assets/Gallery/galleryFood3.jpg'
import galleryFood4 from '../Assets/Gallery/galleryFood4.jpg'
import galleryFood5 from '../Assets/Gallery/galleryFood5.jpg'
import galleryFood6 from '../Assets/Gallery/galleryFood6.jpg'
import galleryFood7 from '../Assets/Gallery/galleryFood7.jpg'
import galleryFood8 from '../Assets/Gallery/galleryFood8.jpg'
import galleryFood9 from '../Assets/Gallery/galleryFood9.jpg'
import galleryFood10 from '../Assets/Gallery/galleryFood10.jpg'
import galleryFood11 from '../Assets/Gallery/galleryFood11.jpg'
import galleryFood12 from '../Assets/Gallery/galleryFood12.jpg'
import galleryFood13 from '../Assets/Gallery/galleryFood13.jpg'
import galleryFood14 from '../Assets/Gallery/galleryFood14.jpg'
import galleryFood15 from '../Assets/Gallery/galleryFood15.jpg'
import galleryFood16 from '../Assets/Gallery/galleryFood16.jpg'
import galleryFood17 from '../Assets/Gallery/galleryFood17.jpg'
import galleryFood18 from '../Assets/Gallery/galleryFood18.jpg'
import galleryFood19 from '../Assets/Gallery/galleryFood19.jpg'
import galleryFood20 from '../Assets/Gallery/galleryFood20.jpg'

import drinkImg1 from '../Assets/Gallery/drinkImg1.jpg'
import drinkImg2 from '../Assets/Gallery/drinkImg2.jpg'
import drinkImg3 from '../Assets/Gallery/drinkImg3.jpg'
import drinkImg4 from '../Assets/Gallery/drinkImg4.jpg'
import drinkImg5 from '../Assets/Gallery/drinkImg5.jpg'
import drinkImg6 from '../Assets/Gallery/drinkImg6.jpg'
import drinkImg7 from '../Assets/Gallery/drinkImg7.jpg'
import drinkImg8 from '../Assets/Gallery/drinkImg8.jpg'
import drinkImg9 from '../Assets/Gallery/drinkImg9.jpg'
import drinkImg10 from '../Assets/Gallery/drinkImg10.jpg'
import drinkImg11 from '../Assets/Gallery/drinkImg11.jpg'

export const GalleryData = [
    {
        id: 1,
        image: galleryImg1,
        category: "interior"
    },
    {
        id: 2,
        image: galleryImg2,
        category: "interior"
    },
    {
        id: 3,
        image: galleryImg3,
        category: "interior"
    },
    {
        id: 4,
        image: galleryImg4,
        category: "interior"
    },
    {
        id: 5,
        image: galleryImg5,
        category: "interior"
    },
    {
        id: 6,
        image: galleryImg6,
        category: "interior"
    },
    {
        id: 7,
        image: galleryImg7,
        category: "interior"
    },
    {
        id: 8,
        image: galleryImg8,
        category: "interior"
    },
    {
        id: 9,
        image: galleryImg9,
        category: "interior"
    },
    {
        id: 10,
        image: galleryImg10,
        category: "interior"
    },
    {
        id: 11,
        image: galleryImg11,
        category: "interior"
    },
    {
        id: 12,
        image: galleryImg12,
        category: "interior"
    },
    {
        id: 13,
        image: galleryImg13,
        category: "interior"
    },
    {
        id: 12,
        image: galleryFood1,
        category: "menu"
    },
    {
        id: 13,
        image: galleryFood2,
        category: "menu"
    },
    {
        id: 14,
        image: galleryFood3,
        category: "menu"
    },
    {
        id: 15,
        image: galleryFood4,
        category: "menu"
    },
    {
        id: 16,
        image: galleryFood5,
        category: "menu"
    },
    {
        id: 17,
        image: galleryFood6,
        category: "menu"
    },
    {
        id: 18,
        image: galleryFood7,
        category: "menu"
    },
    {
        id: 19,
        image: galleryFood8,
        category: "menu"
    },
    {
        id: 20,
        image: galleryFood9,
        category: "menu"
    },
    {
        id: 21,
        image: galleryFood10,
        category: "menu"
    },
    {
        id: 22,
        image: galleryFood11,
        category: "menu"
    },
    {
        id: 23,
        image: galleryFood12,
        category: "menu"
    },
    {
        id: 24,
        image: galleryFood13,
        category: "menu"
    },
    {
        id: 25,
        image: galleryFood14,
        category: "menu"
    },
    {
        id: 26,
        image: galleryFood15,
        category: "menu"
    },
    {
        id: 27,
        image: galleryFood16,
        category: "menu"
    },
    {
        id: 28,
        image: galleryFood17,
        category: "menu"
    },
    {
        id: 29,
        image: galleryFood18,
        category: "menu"
    },
    {
        id: 30,
        image: galleryFood19,
        category: "menu"
    },
    {
        id: 31,
        image: galleryFood20,
        category: "menu"
    },
    {
        id: 32,
        image: drinkImg1,
        category: "drinks"
    },
    {
        id: 33,
        image: drinkImg2,
        category: "drinks"
    },
    {
        id: 34,
        image: drinkImg3,
        category: "drinks"
    },
    {
        id: 35,
        image: drinkImg4,
        category: "drinks"
    },
    {
        id: 36,
        image: drinkImg5,
        category: "drinks"
    },
    {
        id: 37,
        image: drinkImg6,
        category: "drinks"
    },
    {
        id: 38,
        image: drinkImg7,
        category: "drinks"
    },
    {
        id: 39,
        image: drinkImg8,
        category: "drinks"
    },
    {
        id: 40,
        image: drinkImg9,
        category: "drinks"
    },
    {
        id: 41,
        image: drinkImg10,
        category: "drinks"
    },
    {
        id: 42,
        image: drinkImg11,
        category: "drinks"
    },
]